import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { DropboxService } from 'src/app/services/dropbox.service';

@Component({
	selector: 'app-welcome-authenticate',
	templateUrl: './authenticate.component.html',
	styleUrls: ['./authenticate.component.css']
})
export class WelcomeAuthenticateComponent implements OnInit {
	loading = true;
	loadingSignatures = false;

	accountType = '';			// shared = provide an account, connector = use my account
	step: number = 1;			// 1-2
	startedDropboxSignAuth = false;

	error = false;

	signatures = [];

	constructor(
		private fb: UntypedFormBuilder,
		private dropboxService: DropboxService,
		private clientService: ClientService,
		public contextService: ContextService,
		private route: ActivatedRoute,
		private router: Router
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if (params['accountType']) {
				this.accountType = params['accountType'];
			} else if (this.contextService.clientDetailProcore.subscriptionType) {
				this.accountType = this.contextService.clientDetailProcore.subscriptionType;
			}

			// Look for the code param and authenticate the user if not present.
			if (params['error']) {
				this.error = true;
				this.loading = false;
			} else {
				// Determine if the user has a dropbox sign auth token.
				// If no, show the button
				// If yes, get the new token and then navigate to the form
				this.checkForDropboxSignUser();
			}
		});
	}

	checkForDropboxSignUser() {
		this.dropboxService.getDoesUserExistWithSignatureCounts(this.contextService.procoreUserInfo.email, this.contextService.procoreContextObject.context.company_id)
			.subscribe({
				next: (response) => {
					if (response.signatures || response.dropboxSignUsername) {
						this.contextService.signatureCount = response;
					}

					this.router.navigate(['/form']);
				},
				error: () => {
					this.loading = false;
					console.log("this.contextService.clientDetailProcore.nonUsersCanViewStatus:");
					console.log(this.contextService.clientDetailProcore.nonUsersCanViewStatus);
					if (this.contextService.clientDetailProcore.nonUsersCanViewStatus) {
						this.retrieveSignatures();
					}
				}
			});
	}

	authenenticateDropboxSign() {
		if (!this.startedDropboxSignAuth) {
			this.startedDropboxSignAuth = true;

			let username = this.contextService.procoreUserInfo.email;
			let companyId = this.contextService.procoreContextObject.context.company_id;

			this.dropboxService.getAuthUrl(username, companyId).subscribe((redirectUrl) => {
				if (redirectUrl) {
					this.step = 2;

					if (this.contextService.procoreIsSandbox) {
						window.open(redirectUrl + 'https://procore-dbs-dev.shakeit.ai', '_blank');
					} else {
						window.open(redirectUrl + 'https://procore-dbs.shakeit.ai', '_blank');
					}
				}
			});
		}
	}

	continue() {
		this.router.navigate(['/form']);
	}

	retrieveSignatures() {
		console.log("auth - retrieveSignatures");
		this.loadingSignatures = true;
		this.clientService.getSignaturesByProcoreContext(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreUserInfo.email)
			.subscribe((signaturesResult: any) => {
				if (signaturesResult) {
					this.signatures = signaturesResult;
				}
				this.loadingSignatures = false;
			});
	}
}
